import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getImg } from '../utils/getImg';
import defaultArt from '../assets/images/dj_kip_art.png';
import GridCard from './GridCard';
import { useApi } from '../context/ApiProvider';
import { Typography } from '@mui/material';

const LabelCard = ({
  item,
  showFollowOption = true,
  showDetailedInfo = false,
}) => {
  const [isFollowed, setIsFollowed] = useState(false);
  const api = useApi();

  const {
    art_url_sm,
    art_url_xl,
    default_img_sm,
    default_img_xl,
    name,
    id,
    set_count,
    track_count,
    track_genres,
    user_label_stats,
    latest_set_date,
    latest_track_date,
  } = item;

  useEffect(() => {
    const is_followed = user_label_stats?.is_followed || false;
    setIsFollowed(is_followed);
  }, [user_label_stats]);

  const labelImgXl =
    getImg(art_url_xl) ||
    getImg(art_url_sm) ||
    getImg(default_img_xl) ||
    getImg(default_img_sm) ||
    defaultArt;

  async function handleFollowClick() {
    try {
      const response = await api.put(`/stats/label/${id}/follow`);
      if (response.ok) {
        setIsFollowed(response.body.is_followed);
      }
    } catch (error) {
      console.error('Error following label:', error);
    }
  }

  return (
    <GridCard
      title={name}
      art_url={labelImgXl}
      tags={track_genres || []}
      redirectTo={`/labels/${id}`}
      showFollowOption={showFollowOption}
      isFollowed={isFollowed}
      onFollowClick={handleFollowClick}
    >
      {showDetailedInfo && set_count > 0 && (
        <Typography variant="body2">Sets: {set_count}</Typography>
      )}
      {showDetailedInfo && latest_set_date && (
        <Typography variant="body2">
          Latest Set: {new Date(latest_set_date).toLocaleDateString()}
        </Typography>
      )}
      {showDetailedInfo && track_count > 0 && (
        <Typography variant="body2">Tracks: {track_count}</Typography>
      )}
      {showDetailedInfo && latest_track_date && (
        <Typography variant="body2">
          Latest Track: {new Date(latest_track_date).toLocaleDateString()}
        </Typography>
      )}
    </GridCard>
  );
};

LabelCard.propTypes = {
  item: PropTypes.object.isRequired,
  showFollowOption: PropTypes.bool,
  showDetailedInfo: PropTypes.bool,
};

export default LabelCard;
